// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2b6Oi","legacyBtn":"MutateMid_legacyBtn__1vNhM"};